import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, MbsSize, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { POST_PAYMENT_TOKEN } from 'mbs-ui-shared/src/lib/tokens/post-payment.token';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesFacade } from 'mbs-ui-shared@facades/licenses.facade';
import { LicenseType, PermissionsEnum } from 'mbs-ui-shared@models';
import { catchError, map, Observable, of, switchMap, take, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-license-rmm-ce',
  templateUrl: './license-rmm-ce.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonComponent, CanPipe, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class LicenseRMMCEComponent {
  private cdr = inject(ChangeDetectorRef);
  private facade = inject(LicensesFacade);
  private auth = inject(AuthFacade);
  isPostPayment$ = inject<Observable<boolean>>(POST_PAYMENT_TOKEN);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  readonly MbsSize = MbsSize;
  readonly Permissions = PermissionsEnum;

  loading = false;

  handleOk(): void {
    this.loading = true;
    this.cdr.markForCheck();

    this.isPostPayment$
      .pipe(
        take(1),
        switchMap((isPostPayment) =>
          isPostPayment
            ? this.auth.currentUser$.pipe(
                take(1),
                switchMap((user) => this.facade.assignLicenseToAdmin(user.Id, LicenseType.RMM, false)),
                map(() => true),
                catchError(() => of(false))
              )
            : of(true).pipe(tap(() => this.facade.buyLicenseByType('rmm')))
        ),
        catchError(() => of(false)),
        untilDestroyed(this)
      )
      .subscribe((result) => {
        this.loading = false;
        this.cdr.markForCheck();
        result && this.baseModal.save(true);
      });
  }
}
